import React, { FC } from 'react';

import { useDroppable } from '@dnd-kit/core';
import { BottomIcon, TopIcon } from '@smartshell/ui-kit';
import cn from 'classnames';

import s from './GroupWrapper.module.scss';
import { GroupWrapperProps } from './interfaces';

const GroupWrapper: FC<GroupWrapperProps> = ({
  children,
  setIsOpen,
  isOpen,
  title,
  count,
  id,
}) => {
  const { setNodeRef, isOver } = useDroppable({
    id: id,
    data: {
      type: 'Group',
    },
  });

  return (
    <div className={cn(s.container, isOver && s.hover)} ref={setNodeRef}>
      <div className={cn(s.header, isOpen && s.border)} onClick={setIsOpen}>
        <div className={s.info}>
          <span className={s.title}>{title}</span>
          <span className={s.count}>{count}</span>
        </div>
        {isOpen ? <TopIcon size="l" /> : <BottomIcon size="l" />}
      </div>
      <div className={cn(s.body, isOpen && s.open)}>{children}</div>
    </div>
  );
};

export default GroupWrapper;
